<script setup lang="ts">
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { IconCheck } from '@tabler/icons-vue'
import { useLocaleStore } from '@/core/stores/useLocaleStore'
import CountryFlag from '@/core/components/CountryFlag.vue'

const localeStore = useLocaleStore()

const LOCALE_TO_COUNTRY: Record<string, string> = {
  cs: 'cz',
  sk: 'sk',
  en: 'gb'
}
</script>

<template>
  <Menu as="div" class="relative">
    <MenuButton
      class="rail-btn !w-9 !h-9"
      :title="localeStore.current.toUpperCase()"
    >
      <CountryFlag :code="LOCALE_TO_COUNTRY[localeStore.current] || 'gb'" class="w-5 h-auto rounded-sm overflow-hidden" />
    </MenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="absolute right-0 z-50 mt-2 w-40 origin-top-right rounded-xl fg-card shadow-xl ring-1 ring-black/10 focus:outline-none"
      >
        <MenuItem
          v-for="locale in localeStore.availableLocales"
          :key="locale.value"
          v-slot="{ active }"
        >
          <button
            :class="[
              active ? 'bg-white/[0.03]' : '',
              localeStore.current === locale.value ? 'font-medium' : '',
              'flex w-full items-center gap-2.5 px-3 py-2 text-sm text-gray-300'
            ]"
            @click="localeStore.changeLocale(locale.value)"
          >
            <CountryFlag :code="LOCALE_TO_COUNTRY[locale.value] || 'gb'" class="w-5 h-auto rounded-sm overflow-hidden" />
            <span class="flex-1 text-left">{{ locale.label }}</span>
            <IconCheck
              v-if="localeStore.current === locale.value"
              class="h-4 w-4 text-amber-400"
            />
          </button>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>
